// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2-sQb","radioRow":"SimpleQuestionBuilderModal_radioRow__38AC3"};